// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"9e548dcf","407":"7addd6ea","681":"0cbc398a","819":"bb2e807a","831":"b4422599","871":"25a106ed","890":"7484c2a6"}[chunkId] + ".chunk.js";
};